import t from '../../../tools/t'
import { Row } from './FlexContainer'

interface ArchivedStateLabelProps {
    onRestore?: () => void
}

export default function ArchivedStateLabel({ onRestore }: ArchivedStateLabelProps) {
    return (
        <Row gap={1} alignment="center" className="archive-state-label">
            <div className="archive-state-label__warning">{t('common_archived_warning')}</div>
            {onRestore && (
                <div className="archive-state-label__restore" onClick={onRestore}>
                    {t('common_click_to_restore')}
                </div>
            )}
        </Row>
    )
}
